import { ChevronRight } from "lucide-react";
import { TopicItem } from "../../../types";
import { getTopicVisual } from "@/lib/topicConfig";
import "./index.css";

interface TopicListProps {
    selectedTopic: String | null;
    topicList: TopicItem[];
    handleClickSelectTopic: (key: string) => Promise<void>;
    /** Pixel offset (e.g. `200px`) used in `max-height: calc(100dvh - …)` so the list scrolls inside the viewport. */
    scrollHeight: String;
}

function topicListMaxHeight(scrollHeight: String): string {
    const raw = String(scrollHeight ?? "").trim();
    // Callers pass values like "200px" / "370px" (legacy: subtract from viewport for list chrome).
    if (/^[\d.]+px$/i.test(raw)) {
        return `max(10rem, min(calc(100dvh - ${raw}), calc(100vh - ${raw})))`;
    }
    return "max(10rem, min(72dvh, calc(100dvh - 12rem)))";
}

export default function TopicList({
    selectedTopic,
    topicList,
    handleClickSelectTopic,
    scrollHeight,
}: TopicListProps) {
    const listMaxH = topicListMaxHeight(scrollHeight);

    return (
        <div
            className="topic-list-root flex min-h-0 min-w-0 max-h-full flex-1 flex-col overflow-hidden"
            style={{
                boxShadow: "0 4px 6px -4px rgba(0, 0, 0, 0.2)",
            }}
        >
            <div
                className="topic-list-scroll min-h-0 flex-1 overflow-y-auto overflow-x-hidden overscroll-contain"
                style={{ maxHeight: listMaxH, WebkitOverflowScrolling: "touch" }}
            >
                {topicList.map((item: TopicItem) => {
                    const visual = getTopicVisual(item.key);
                    const Icon = visual.icon;
                    const isActive = selectedTopic === item.key;

                    return (
                        <div
                            key={item.id}
                            className={isActive ? "topic-card active" : "topic-card"}
                            style={isActive ? { borderColor: visual.iconColor } : undefined}
                            onClick={() => handleClickSelectTopic(item.key)}
                        >
                            <div
                                className="topic-card-icon"
                                style={{
                                    backgroundColor: visual.iconBg,
                                    color: visual.iconColor,
                                }}
                            >
                                <Icon className="topic-card-icon-svg" aria-hidden />
                            </div>
                            <span className="topic-card-label">{item.text}</span>
                            <ChevronRight className="topic-card-chevron" aria-hidden />
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
